// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportHistoryBar.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import Button from 'share/components/controls/Izenda.Button';
import IconMenu from 'share/components/controls/Izenda.IconMenu';
import PropTypes from 'prop-types';
import actions from './Izenda.ImportHistoryBarActions';
import connect from 'share/enhancers/Izenda.Connect';

@connect(actions)
export default class ImportHistoryBar extends Component {
  static propTypes = {
    store: PropTypes.object,
    loadHistories: PropTypes.func
  };

  render() {
    const {
      localization,
      store: { model }
    } = this.props;

    return (
      <section className="izenda-Wrapper-header">
        <IconMenu className="u_marginRightInnerSpace" />
        <div className="izenda-ActionBarRight">
          <Button
            disabled={model.isNoChecked}
            onClick={this.props.handleDelete}
            label={localization.getText('COMMON_LABEL_DELETE')}
          />
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/ImportHistory/ActionBar/Izenda.ImportHistoryBar.js